export function copyColumnKeys(target, dataSource, columns) {
    return columns.reduce((d, col) => {
        const key = col.get('_key');
        return d.has(key) ? d : d.set(key, dataSource.get(key));
    }, target);
}
